import React, { memo, forwardRef } from "react";
const SvgApproximation = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeWidth={2}
        d="M9 14.611l1.58-1.304A4.087 4.087 0 0116 13.5v0a4.087 4.087 0 005.42.193L23 12.389M9 20.611l1.58-1.303A4.087 4.087 0 0116 19.5v0a4.087 4.087 0 005.42.192L23 18.39"
      />
    </svg>
  );
});
SvgApproximation.displayName = "SvgApproximation";
const MemoForwardRef = memo(SvgApproximation);
export default MemoForwardRef;
